import { getApiUrl } from "../config";


export async function logoutAllDevices() {
    const res = await fetch(getApiUrl('/api/logout-all'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Failed to logout all devices')
    }
    return res.json()
}

export async function logoutDevice(sessionId: string) {
    const res = await fetch(getApiUrl('/api/logout-device'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
    });
    if (!res.ok) {
        throw new Error('Failed to logout device')
    }
    return res.json()
}

export async function forgotPassword(email: string) {
    const res = await fetch(getApiUrl('/api/forgot-password'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
    });
    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to send reset email')
    }
    return res.json()
}

export async function resetPassword(token: string, password: string) {
    const res = await fetch(getApiUrl('/api/reset-password'), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, password }),
    });
    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to reset password')
    }
    return res.json()
}
